module.exports = __webpack_public_path__ + "static/media/kv-ko.e5f638d6.jpg";